import { useLang } from 'hooks/lang';

import { Column } from 'components/Blocks';

import { RecruitmentStatuses } from './Statuses';
import { RecruitmentList } from './RecruitmentList';

import { withRecruitmentHomeContext } from './context';

export type Counts = Record<string, number>;

function RecruitmentHome() {
  const { t } = useLang();

  return (
    <Column>
      <h5 className="text-2xl font-semibold text-primary">{t('recruitment-dashboard')}</h5>

      <RecruitmentStatuses />

      <RecruitmentList />
    </Column>
  );
}

export default withRecruitmentHomeContext(RecruitmentHome);
